/** @file Resolves the active skin list into one combined skin: default underneath, later entries win. */
import { skinAt } from '../_internal/skinAt';
import type { SkeletonData, SkinData } from '../skeletonData';
import { combineSkins } from './combineSkins';

/** Combined skin: later entries win; the default skin sits underneath (appended automatically). */
export function resolveSkin(data: SkeletonData, skins: number[]): SkinData {
  for (const [i, index] of skins.entries()) skinAt(data, index, `skins[${i}]`);
  return combineSkins(data, data.defaultSkin >= 0 ? [data.defaultSkin, ...skins] : skins);
}
